import React, { useCallback } from 'react';
import styled from 'styled-components';
import { FlexCenter } from '@ubeya/shared-web/components';
import PlusButton from 'scheduling/components/PlusButton';

const ShiftsWrapper = styled.div`
  .plus-button {
    visibility: visible;
    margin-right: 20px;
  }
`;

const DayStrip = styled.div`
  background-color: ${({ theme }) => theme.colors.grey1};
  padding: 8px 32px;
  width: 100%;
`;

const DayTitle = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: ${({ theme, today }) => (today ? theme.colors.primary : theme.colors.black)};
`;

const Chips = styled(FlexCenter)`
  flex: 1;
  flex-wrap: wrap;
  margin-left: 10px;
  justify-content: start;
  padding: 8px 12px;
`;

const Content = styled(FlexCenter)`
  align-items: center;
  min-height: 60px;
`;

const Availability = styled.div`
  color: ${({ theme, available }) => (available ? theme.colors.greenPositive : theme.colors.redNegative)};
`;

const AvailabilitySplitter = styled.div`
  width: 3px;
  height: 30px;
  background-color: ${({ theme, available }) => (available ? theme.colors.greenPositive : theme.colors.redNegative)};
  margin-right: 10px;
`;

const AvailabilityRow = styled.div``;

const AvailabilityItem = ({ data, index, setOpenGeneralAvailability, dayOfWeek, getFormattedStatusByType }) => {
  const available = data ? data.available : true;

  const onClick = useCallback(() => setOpenGeneralAvailability({ data, selectedDay: { index, title: dayOfWeek } }), [
    data,
    dayOfWeek,
    index,
    setOpenGeneralAvailability
  ]);

  return (
    <AvailabilityRow key={index}>
      <DayStrip>
        <DayTitle>{dayOfWeek}</DayTitle>
      </DayStrip>

      <Content>
        <Chips>
          <AvailabilitySplitter available={available} />
          <Availability available={available}>{getFormattedStatusByType(data)}</Availability>
        </Chips>
        <ShiftsWrapper onClick={onClick}>
          <PlusButton className="plus" />
        </ShiftsWrapper>
      </Content>
    </AvailabilityRow>
  );
};

export default AvailabilityItem;
